module.exports = {"data":{"site":{"siteMetadata":{"title":"Razy Technologies"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/projects/interactive-messaging-test/"},"frontmatter":{"title":"Interactive Messaging"}}}]}},"pathContext":{"tag":"messaging"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-messaging.json
// module id = 470
// module chunks = 192013037598841